<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="shopsSelected"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
    :items="shopsItems"
    :loading="shopsLoading"
    :search-input.sync="shopsSearch"
    item-text="Description"
    item-value="id"
    :label="label ? label : $consts.shopName()"
    return-object
  ></v-autocomplete>
  <!-- menu-props="closeOnContentClick" -->
</template>

<script>
import Shops from "@/api/shops";

export default {
  name: "SearcherShops",

  props: [
    "value",
    "districtID",
    "allianceBusinessIds",
    "isCompanyName",
    "label",
  ],

  computed: {
    shopsItems() {
      return this.shops.map((shop) => {
        let Description = shop.shop_code + " / " + shop.shop_name;
        if (this.isCompanyName && shop.company_name != null) {
          Description = Description + " 【" + shop.company_name + "】";
        }
        return Object.assign({}, shop, { Description });
      });
    },
  },

  data: () => ({
    shops: [],
    shopsLoading: false,
    shopsSearch: "",
    shopsSelected: [],
  }),

  mounted() {
    this.getShopsFromAPI();
  },

  methods: {
    getShopsFromAPI() {
      this.shopsLoading = true;
      Shops.fetchAllForSelect({
        district_id: this.districtID,
        alliance_business_ids: this.allianceBusinessIds,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.shops = response.data.shops;
            }
            this.shopsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.shopsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.shopsSelected = this.value;
      },
    },
    shopsSelected: {
      handler() {
        this.$emit("input", this.shopsSelected);
      },
    },
    districtID: {
      handler() {
        this.getShopsFromAPI();
      },
    },
    allianceBusinessIds: {
      handler() {
        this.getShopsFromAPI();
      },
    },
  },
};
</script>
